import {KeasyBootstrap} from './keasy-bootstrap';

declare let window: KeasyBootstrap;
let angle: number = 360;


function setAndRemoveImageRotationClasses(angle: number, marginTop: number, img: HTMLElement): void {
  img.classList.add("rotate" + angle)

  if (angle == 90 || angle == 270) {
    img.style.marginTop = marginTop + "px";
  } else img.style.marginTop = "0px";

  if (angle != 90 && img.classList.contains("rotate90")) {
    img.classList.remove("rotate90")
  }
  if (angle != 180 && img.classList.contains("rotate180")) {
    img.classList.remove("rotate180")
  }
  if (angle != 270 && img.classList.contains("rotate270")) {
    img.classList.remove("rotate270")
  }
  if (angle != 0 && img.classList.contains("rotate0")) {
    img.classList.remove("rotate0")
  }
}

function attachEventListeners(event: Event): void {
  const actions = document.querySelectorAll('[data-toggle="rotate"]');

  if (!actions) {
    return;
  }

  actions.forEach((action: Element) => {
    const img = document.getElementById((action as HTMLElement).dataset.target);
    const event = action.getAttribute('data-rotate-image-event') || 'click';
    const rotationAngle: number = parseInt(action.getAttribute('data-rotation-angle'));

    action.addEventListener(event, () => {
      const width = img.clientWidth;
      const height = img.clientHeight;

      const marginTop = (width - height) / 2;

      angle = (angle + rotationAngle) % 360;
      if (angle < 0 && rotationAngle < 0) angle = 360 + rotationAngle;

      setAndRemoveImageRotationClasses(angle, marginTop, img)
    });
  })
}

window.addEventListener('DOMContentLoaded', (event) => {
  attachEventListeners(event);
}, {once: true})

